import { render, staticRenderFns } from "./colorSkin.vue?vue&type=template&id=706ea7ae&"
import script from "./colorSkin.vue?vue&type=script&lang=ts&"
export * from "./colorSkin.vue?vue&type=script&lang=ts&"
import style0 from "./colorSkin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports